import {
    getListOfValue
    , getListOfValueType
    , insertListOfValue
    , updateListOfValue
    , getListOfValueByType

} from '../utils/listofvalue-api-action';


const getType = async () => {
    var result = await getListOfValueType()
    return result;

}

const search = async (param) => {
    var result = await getListOfValue(param)
    return result;

}

const insert = async (param) => {
    var result = await insertListOfValue(param)
    return result;

}

const update = async (param) => {
    var result = await updateListOfValue(param)
    return result;

}

const getByType = async (param) => {
    var result = await getListOfValueByType(param)
    return result;

}

//const lookupSearch = async (param) => {
//    var result = await getListOfValueLookup(param)
//    return result;

//}



export {

    getType
    , search
    , insert
    , update
    , getByType
    //, lookupSearch

};
